import { QueryClient } from "@tanstack/react-query"
import { createRouter } from "@tanstack/react-router"

import PendingComponent from "./globalComponents/atoms/PendingComponent"
import { routeTree } from "./routeTree.gen"

export const queryClient = new QueryClient()

export const router = createRouter({
  routeTree,
  defaultPreload: false,
  defaultPreloadStaleTime: 0,
  context: {
    queryClient,
    setScannedArea: undefined!,
    setDocumentThemeMode: undefined!,
    /*
      Bang because we are passing it before the router
      enters react land and we don't want to check
      optionality every time we use it :/
    */
  },
  defaultPendingComponent: PendingComponent,
  notFoundMode: "root",
  unmaskOnReload: true,
})

// Register router for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
